/*
---
name: DisplayObject
description: Standard object inheriting additional common element behavior.
authors:
- David Chan CK (http://www.reol.com)
license:
- MIT-style license
requires:
- core/1.2.4: '*'
provides: [DisplayObject]
...
*/
var DisplayObject = new Class
({
	Implements: [Events],
	initialize: function()
	{
		this.build();
		return;
	},
	build: function()
	{
		this.is_visible = false;
		this._element;
		this.fx_element = new Fx.Morph($(this), {link: 'cancel'});
	},
	fade_in: function(e)
	{
		this.stop_event(e);
		
		this.fx_element.start(
		{
			opacity: 1
		}).chain(this.fireEvent.bind(this, 'onFadeIn'));
		
		return this;
	},
	fade_out: function(e)
	{
		this.stop_event(e);
		
		this.fx_element.start(
		{
			opacity: 0
		}).chain(this.fireEvent.bind(this, 'onFadeOut'));
		
		return this;
	},
	hide: function(e)
	{
		this.stop_event(e);
		$(this).setStyle('display', 'none');
		return this;
	},
	show: function(e)
	{
		this.stop_event(e);
		$(this).setStyle('display', 'block');
		return this;
	},
	stop_event: function(e)
	{
		if (e && e.stop)
		{
			e.stop(); 
		}
	},
	toElement: function()
	{
		return this._element;
	}
});
